import classNames from "classnames";
import { Dot } from "pure-react-carousel";
import React from "react";

export function RenderDots(props: {
  currentSlide?: number;
  totalSlides?: number;
}) {
  const { currentSlide = 0, totalSlides = 0 } = props;
  const dots = [];
  for (let i = 0; i < totalSlides; i++) {
    const current = currentSlide === i;
    const dot = (
      <Dot
        key={i}
        slide={i}
        className={classNames(
          "h-10px w-10px lg:h-20px lg:w-20px",
          current ? "bg-hyacinth" : "bg-coal",
        )}
      />
    );
    dots.push(dot);
  }
  return dots;
}
